export default __webpack_public_path__ + "static/media/02 Welcome Screen – 1@3x.f8f5253b.png";